import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { Remove} from '@mui/icons-material';


const AcceptedDialog = ({visible,setVisible,data,setData})=>{

	const theme = useTheme()
	const dispatch = useDispatch()

	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Participants
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
			{
				data?.length == 0 && (
					<Box>
						<Typography m={1} style={{fontSize:15,fontWeight:400,color:"gold"}}>
							There isn't any accepted participants
						</Typography>
					</Box>
				)
			}
			{
				data?.map((item,index)=>{
					return(
						<Box key={index}>
							<Box sx={{ display:"flex",flexDirection:"row",justifyContent:"space-evenly",alignContent:"center",width:"100%"}}>
								<Typography  mt={4} style={{fontSize:15,fontWeight:400}}>
									# {index+1}
								</Typography>
								<Box textAlign="left">
									<Typography m={1} style={{fontSize:11,fontWeight:400,color:"gold",fontFamily:"dinofans"}}>
										{item?.first_name} {item?.last_name}
									</Typography>
									<Typography m={1} style={{fontSize:13,fontWeight:400,color:"grey"}}>
										{item?.email}
									</Typography>
									<Typography m={1} style={{fontSize:13,fontWeight:400,color:"grey"}}>
										{item?.score} %
									</Typography>										
								</Box>
								<IconButton>
									<Remove fontSize="small" sx={{color:"red"}}/>
								</IconButton>								
							</Box>
						</Box>
					)
				})
			}
		</DialogContent>
	</Dialog>
	)
}

export default AcceptedDialog;